import React from 'react';
import { Card, OverlayTrigger, Tooltip } from 'react-bootstrap';
// TODO: Rename this css file and use for others
import './bloodwork-anemia-status.css';
import { LabsmartsGuage } from '../charts/LabsmartsGauge';
import { BloodworkAnalysis } from '../../models/BloodworkAnalysis';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
const arrow_up = require('../../assets/imgs/long-arrow-up-8x13.png');
const arrow_down = require('../../assets/imgs/long-arrow-down-8x12.png');
const arrowUpStyle: React.CSSProperties = {
  height: '11px',
  margin: '0 3px',
  verticalAlign: 'middle',
  position: 'relative',
  top: '-0.5px'
};

const arrowDownStyle: React.CSSProperties = {
  height: '11px',
  margin: '0 3px',
  verticalAlign: 'middle',
  position: 'relative',
  top: '-0.5px'
};

type Props = {
  bloodworkAnalysis: BloodworkAnalysis;
};
export class WBCEvaluation extends React.Component<Props, {}> {

  renderArrow(direction, marker) {
    return (
      <>
        <img src={direction === 'up' ? arrow_up : arrow_down} alt={direction === 'up' ? '↑' : '↓'} style={direction === 'up' ? arrowUpStyle : arrowDownStyle} />
        {marker}
      </>
    );
  }

  // Patterns 1 & 2 (july 2025)
  renderImmuneActivityStatus = (bloodworkAnalysis) => {
    const wbc = bloodworkAnalysis?.wbc;
    if (!wbc?.hasValue?.()) return null;
  
    let text = "";
  
    if (wbc.isGreaterThanLab?.() || wbc.isGreaterThanOptimal?.()) {
      text = "Acute Immune Activity";
    } else if (wbc.isLessThanLab?.() || wbc.isLessThanOptimal?.()) {
      text = "Suppressed Immune Activity";
    } else {
      return null; // hide box if WBC is optimal
    }
  
  return (
    <div className="condition-section">
      <div>{text}</div>
      <div>
        <span style={{ color: 'black' }}>
          {wbc.isGreaterThanLab?.() || wbc.isGreaterThanOptimal?.()
          ? this.renderArrow("up", "WBC")
          : wbc.isLessThanLab?.() || wbc.isLessThanOptimal?.()
          ? this.renderArrow("down", "WBC")
          : "WBC"}
        </span>
      </div>
    </div>
  );
}; // This closes renderImmuneActivityStatus correctly


  //Pattern 3 & 4
  renderImmuneResponseBalance = (bloodworkAnalysis) => {
    const nlr = bloodworkAnalysis?.nlr;
    if (!nlr?.hasValue?.()) return null;
  
    if (nlr.isGreaterThanLab?.() || nlr.isGreaterThanOptimal?.()) {
      return (
        <div className="condition-section">
          <div style={{ color: 'black', textAlign: 'left' }}>
          Innate Immune Response to:
          </div>
          <div style={{ textAlign: 'left' }}>
            <ul style={{ paddingLeft: '12px', marginLeft: 0, listStylePosition: 'inside' }}>
              <li>Bacterial Activity</li>
              <li>Acute Inflammatory Activity</li>
              <li>Acute Stress</li>
            </ul>
          </div>
          <div style={{ color: 'black', textAlign: 'right' }}>
            {this.renderArrow("up", "NLR")}
          </div>
        </div>
      );
    }
  
    if (nlr.isLessThanLab?.() || nlr.isLessThanOptimal?.()) {
      return (
        <div className="condition-section">
          <div style={{ color: 'black', textAlign: 'left' }}>
          Adaptive Immune Response to:
          </div>
          <div style={{ textAlign: 'left' }}>
            <ul style={{ paddingLeft: '12px', marginLeft: 0, listStylePosition: 'inside' }}>
              <li>Viral Activity</li>
              <li>Autoimmunity</li>
              <li>Chronic Stress</li>
            </ul>
          </div>
          <div style={{ color: 'black', textAlign: 'right' }}>
            {this.renderArrow("down", "NLR")}
          </div>
        </div>
      );
    }
  
    return null; // hide box if NLR is optimal
  };
  
  // Pattern 5
  renderAcuteInnateImmuneResponseBox = (analysis) => {
    const wbc = analysis?.wbc;
    const nlr = analysis?.nlr;

    const wbcHigh = wbc?.isGreaterThanLab?.() || wbc?.isGreaterThanOptimal?.();
    const nlrHigh = nlr?.isGreaterThanLab?.() || nlr?.isGreaterThanOptimal?.();

    if (wbcHigh && nlrHigh) {
    return (
      <div className="condition-section">
        <div style={{ color: 'black', textAlign: 'left' }}>
        Acute Innate Immune Response to:
        </div>
        <div style={{ textAlign: 'left' }}>
          <ul style={{ paddingLeft: '12px', marginLeft: 0, listStylePosition: 'inside' }}>
            <li>Bacterial Activity</li>
            <li>Acute Inflammatory Activity</li>
            <li>Acute Stress</li>
          </ul>
        </div>
        <div style={{ color: 'black', textAlign: 'right' }}>
          {this.renderArrow("up", "WBC")},{'\u00A0'}
          {this.renderArrow("up", "NLR")}
        </div>
      </div>
      );
   }

  return null;
  };

  // Pattern 6
  renderAcuteAdaptiveImmuneResponse = (analysis) => {
    const wbc = analysis?.wbc;
    const nlr = analysis?.nlr;

    if (
      (wbc?.isGreaterThanLab?.() || wbc?.isGreaterThanOptimal?.()) &&
      (nlr?.isLessThanLab?.() || nlr?.isLessThanOptimal?.())
    ) {
      return (
        <div className="condition-section">
        <div style={{ color: 'black', textAlign: 'left' }}>
        Acute Adaptive Immune Response to:
        </div>
            <div style={{ textAlign: 'left' }}>
              <ul style={{ paddingLeft: '12px', marginLeft: 0, listStylePosition: 'inside' }}>
                <li>Viral Activity</li>
                <li>Autoimmunity</li>
                <li>Chronic Stress</li>
              </ul>
            </div>
            <div style={{ color: 'black', textAlign: 'right' }}>
              {this.renderArrow("up", "WBC")},{'\u00A0'}
              {this.renderArrow("down", "NLR")}
            </div>
          </div>
      );
    }

  return null;
  };

  // Pattern 7
  renderChronicInnateImmuneResponse = (analysis) => {
    const wbc = analysis?.wbc;
    const nlr = analysis?.nlr;

    const wbcLow = wbc?.isLessThanLab?.() || wbc?.isLessThanOptimal?.();
    const nlrHigh = nlr?.isGreaterThanLab?.() || nlr?.isGreaterThanOptimal?.();

    if (wbcLow && nlrHigh) {
      return (
        <div className="condition-section">
          <div style={{ color: 'black', textAlign: 'left' }}>
          Chronic Innate Immune Response to:
          </div>
          <div style={{ textAlign: 'left' }}>
            <ul style={{ paddingLeft: '12px', marginLeft: 0, listStylePosition: 'inside' }}>
              <li>Ongoing Bacterial Activity</li>
              <li>Chronic Inflammatory Activity</li>
              <li>Unresolved Acute Stress</li>
            </ul>
          </div>
          <div style={{ color: 'black', textAlign: 'right' }}>
            {this.renderArrow("down", "WBC")},{'\u00A0'}
            {this.renderArrow("up", "NLR")}
          </div>
        </div>
      );
    }

    return null;
  };
  
  // Pattern 8
  renderChronicAdaptiveImmuneResponse = (analysis) => {
    const wbc = analysis?.wbc;
    const nlr = analysis?.nlr;

    const wbcLow = wbc?.isLessThanLab?.() || wbc?.isLessThanOptimal?.();
    const nlrLow = nlr?.isLessThanLab?.() || nlr?.isLessThanOptimal?.();

    if (wbcLow && nlrLow) {
      return (
        <div className="condition-section">
          <div style={{ color: 'black', textAlign: 'left' }}>
            Chronic Adaptive Immune Response to:
          </div>
            <div style={{ textAlign: 'left' }}>
              <ul style={{ paddingLeft: '12px', marginLeft: 0, listStylePosition: 'inside' }}>
                <li>Viral Activity</li>
                <li>Autoimmunity</li>
                <li>Chronic Stress</li>
              </ul>
            </div>
          <div style={{ color: 'black', textAlign: 'right' }}>
            {this.renderArrow("down", "WBC")},{'\u00A0'}
            {this.renderArrow("down", "NLR")}
          </div>
        </div>
      );
    }

    return null;
  };



  isEosinophilsHigh = (analysis) => {
    const eosAbs = analysis?.eosinophilsAbs;
    const eosPct = analysis?.eosinophils;
    return eosAbs?.isGreaterThanOptimal?.() || eosAbs?.isGreaterThanLab?.()
      || eosPct?.isGreaterThanOptimal?.() || eosPct?.isGreaterThanLab?.();
  };
  
  isMonocytesHigh = (analysis) => {
    const monoAbs = analysis?.monocytesAbs;
    const monoPct = analysis?.monocytes;
    return monoAbs?.isGreaterThanOptimal?.() || monoAbs?.isGreaterThanLab?.()
      || monoPct?.isGreaterThanOptimal?.() || monoPct?.isGreaterThanLab?.();
  };
  
  isBasophilsHigh = (analysis) => {
    const basoAbs = analysis?.basophilsAbs;
    const basoPct = analysis?.basophils;
    return basoAbs?.isGreaterThanOptimal?.() || basoAbs?.isGreaterThanLab?.()
      || basoPct?.isGreaterThanOptimal?.() || basoPct?.isGreaterThanLab?.();
  };

  shouldShowImmuneCleanupRepair = (analysis) => {
    const monoHigh = this.isMonocytesHigh(analysis);
    const basoHigh = this.isBasophilsHigh(analysis);
  
    // Show only when mono is high and baso is normal
    return monoHigh && !basoHigh;
  };
  
  // Pattern 13
  renderEosinophilsAlone = (analysis) => {
    const eosHigh = this.isEosinophilsHigh(analysis);
    const monoHigh = this.isMonocytesHigh(analysis);
    const basoHigh = this.isBasophilsHigh(analysis);
  
    if (eosHigh && !monoHigh && !basoHigh) {
      return (
        <div className="condition-section">
          <div>Possible Sensitivity Response (IgG) to</div>
          <div>Food or Environmental Antigen</div>
            <span style={{ color: 'black' }}>
            <img src={arrow_up} alt="↑" style={arrowUpStyle} />
            Eos
            </span>
        </div>
      );
    }
    return null;
  };
  
  // Pattern 14
  renderBasoMonoPattern = (analysis) => {
    const monoHigh = this.isMonocytesHigh(analysis);
    const basoHigh = this.isBasophilsHigh(analysis);
  
    if (monoHigh && basoHigh) {
      return (
        <div className="condition-section">
          <div>Immune Cleanup and Repair with</div>
          <div>Possible Histamine Release</div>
          <span style={{ color: 'black' }}>
                <img src={arrow_up} alt="↑" style={arrowUpStyle} />
                Mono,&nbsp;
                <img src={arrow_up} alt="↑" style={arrowUpStyle} />
                Baso&nbsp;
              </span>
        </div>
      );
    }
    return null;
  };

  isParasiticPatternPresent = (bloodworkAnalysis) => {
    const eosAbs = bloodworkAnalysis?.eosinophilsAbs;
    const eosPct = bloodworkAnalysis?.eosinophils;
    const monoAbs = bloodworkAnalysis?.monocytesAbs;
    const monoPct = bloodworkAnalysis?.monocytes;
  
    const eosHigh =
        eosAbs?.isGreaterThanOptimal?.() || eosAbs?.isGreaterThanLab?.() ||
        eosPct?.isGreaterThanOptimal?.() || eosPct?.isGreaterThanLab?.();
  
      const monoHigh =
        monoAbs?.isGreaterThanOptimal?.() || monoAbs?.isGreaterThanLab?.() ||
        monoPct?.isGreaterThanOptimal?.() || monoPct?.isGreaterThanLab?.();
  
      return eosHigh && monoHigh;
    };
  
    renderParasiticActivityBox = (analysis) => {
      const eosHigh = this.isEosinophilsHigh(analysis);
      const monoHigh = this.isMonocytesHigh(analysis);
      const basoHigh = this.isBasophilsHigh(analysis);
    
      // Pattern 10
      if (eosHigh && monoHigh) {
        return (
          <div className="condition-section">
            <div style={{ color: 'black', textAlign: 'left' }}>
            Possible Immune Reactivity Response to
            </div>
            <div style={{ color: 'black', textAlign: 'left' }}>
            Chronic Antigen Exposure:
            </div>
            <div style={{ textAlign: 'left' }}>
              <ul style={{ paddingLeft: '12px', marginLeft: 0, listStylePosition: 'inside' }}>
                <li>Food Sensitivities</li>
                <li>Environmental Toxins</li>
                <li>Parasitic Activity</li>
              </ul>
            </div>

            <span style={{ color: 'black' }}>
              <img src={arrow_up} alt="↑" style={arrowUpStyle} />
              Eos,&nbsp;
              <img src={arrow_up} alt="↑" style={arrowUpStyle} />
              Mono
              {basoHigh && ( // Pattern 9
                <>
                  ,&nbsp;
                  <img src={arrow_up} alt="↑" style={arrowUpStyle} />
                  Baso
                </>
              )}
            </span>
          </div>
        );
      }
      
      // Pattern 11
      if (eosHigh && basoHigh && !monoHigh) {
        return (
          <div className="condition-section">
            <div>Possible Allergic Response (IgE) to</div>
            <div>Food or Environmental Antigen</div>
              <span style={{ color: 'black' }}>
                <img src={arrow_up} alt="↑" style={arrowUpStyle} />
                Eos,&nbsp;
                <img src={arrow_up} alt="↑" style={arrowUpStyle} />
                Baso
              </span>
          </div>
        );
      }
    
      return null;
    };    
    
    // Pattern 12
    renderMonocyteEvaluation = (analysis) => {
      if (!this.shouldShowImmuneCleanupRepair(analysis)) return null;
    
      return (
        <div className="condition-section">
            <div>Immune Cleanup and Repair</div>
            <span style={{ color: 'black' }}>
              <img src={arrow_up} alt="↑" style={arrowUpStyle} />
              Mono
            </span>
        </div>
      );
    };
       
    // Pattern 15
    renderBasophilEvaluation = (analysis) => {
      const eosHigh = this.isEosinophilsHigh(analysis);
      const monoHigh = this.isMonocytesHigh(analysis);
      const basoHigh = this.isBasophilsHigh(analysis);
    
      // Suppress if parasitic activity pattern is present (all three high)
      if (eosHigh && monoHigh && basoHigh) return null;
    
      // Suppress if eos + baso (allergic response pattern)
      if (eosHigh && basoHigh && !monoHigh) return null;
    
      // Suppress if mono + baso (baso-mono pattern)
      if (!eosHigh && monoHigh && basoHigh) return null;
    
      if (!basoHigh) return null;
    
      return (
        <div className="condition-section">
          <div>Possible Inflammation / Immune Activation</div>
            <span style={{ color: 'black' }}>
              <img src={arrow_up} alt="↑" style={arrowUpStyle} />
              Baso
            </span>
          </div>
      );
    };
    
 
  openWindow = () => {
    window.open('https://labsmarts.com/testresultsanalysis/#wbc');
  }

  render() {
  const { bloodworkAnalysis } = this.props;
  if (!bloodworkAnalysis.bloodwork) return null;
  // const showAcuteInnate = this.renderAcuteInnateImmuneResponseBox(bloodworkAnalysis);
  // const showAcuteAdaptive = this.renderAcuteAdaptiveImmuneResponse(bloodworkAnalysis);

  const wbc = bloodworkAnalysis?.wbc;

  // Hide panel entirely if WBC has no value
  if (!wbc?.hasValue?.()) return null;


  const showAcuteInnate = this.renderAcuteInnateImmuneResponseBox(bloodworkAnalysis);
  const showAcuteAdaptive = this.renderAcuteAdaptiveImmuneResponse(bloodworkAnalysis);
  const showChronicInnate = this.renderChronicInnateImmuneResponse(bloodworkAnalysis);
  const showChronicAdaptive = this.renderChronicAdaptiveImmuneResponse(bloodworkAnalysis);
  const showImmuneActivity = this.renderImmuneActivityStatus(bloodworkAnalysis);
  const showImmuneBalance = this.renderImmuneResponseBalance(bloodworkAnalysis);
  const showNoMajorPatterns = !showAcuteInnate && !showAcuteAdaptive && !showChronicInnate && !showChronicAdaptive; //Only show WBC Immune Activity if none of the bigger WBC+NLR patterns triggered.

  const panelTooltip = (
    <Tooltip id="modal-tooltip">
      Click this icon to learn more about the items in this panel.
    </Tooltip>
  );

  return (
    <Card className="evaluationPanel" id="wbc-evaluation">
      <Card.Header className="evaluationPanelHeading">
        Immune System Insights&nbsp;
        <OverlayTrigger overlay={panelTooltip}>
          <FontAwesomeIcon icon="external-link-alt" onClick={this.openWindow} />
        </OverlayTrigger>
      </Card.Header>
      <Card.Body>
        <div className="anemiaStatusContainer">
          <LabsmartsGuage
            text="Immune System Abnormality is"
            chartContainerId="anemiaStatusGuage"
            bloodwork={bloodworkAnalysis.bloodwork}
            category={bloodworkAnalysis.wbcAnalysis.immuneSystemDisorderProbabilityCategory}
            probability={bloodworkAnalysis.wbcAnalysis.immuneSystemDisorderProbability}
          />


          {showAcuteInnate}
          {showAcuteAdaptive}
          {showChronicInnate}
          {showChronicAdaptive}

          {showNoMajorPatterns && showImmuneActivity}
          {showNoMajorPatterns && showImmuneBalance}

          {this.renderParasiticActivityBox(bloodworkAnalysis)}
          {this.renderMonocyteEvaluation(bloodworkAnalysis)}
          {this.renderBasophilEvaluation(bloodworkAnalysis)}
          {this.renderEosinophilsAlone(bloodworkAnalysis)}
          {this.renderBasoMonoPattern(bloodworkAnalysis)}
        </div>
      </Card.Body>
    </Card>
    )
  }
};